import React from 'react';
import { Alert } from '@parsina/framework';
import { AlertTriangle } from 'lucide-react';
import { C } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';

// The persistent allergy safety strip (§4C ③).
//
// «The safety strip and the navigator are the only sticky chrome. The header and
// the identity glance scroll away — the record wins the viewport — but a
// critical allergy stays visible at every scroll position.»
//
// The BANNER is the kit's `Alert variant="warning"`; what is app-local is the
// decision that it belongs in the record's sticky block at all, which is a
// record-screen decision and not a property of an alert. The screen owns the
// `position: sticky` — the strip and the section navigator stick TOGETHER as one
// block, because sticking them separately means guessing the strip's height,
// which depends on how many allergens wrap.
//
// It renders nothing when there is nothing to warn about — a permanent empty
// band would train the dentist to ignore the position.

const MobileAllergyStrip = ({ allergies }) => {
  const { t } = useTranslation();
  const list = (allergies || []).map((a) => a.allergen).filter(Boolean);
  if (list.length === 0) return null;

  return (
    <div
      data-testid="patient-allergy-strip"
      style={{
        padding: '0.5rem 0.75rem 0',
        // Opaque, not transparent: this sits in a sticky block, and the cards
        // scrolling underneath would otherwise show through the Alert's soft
        // tint and make the allergen text unreadable exactly while it matters.
        background: C.bg,
      }}
    >
      <Alert
        variant="warning"
        icon={<AlertTriangle size={16} />}
        title={t('patient.summary.allergyWarning')}
      >
        {list.join(' · ')}
      </Alert>
    </div>
  );
};

export default MobileAllergyStrip;
